import React, {useRef} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Keyboard, Navigation, Pagination} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

import {eventEmitter} from '../../common/baseData';

function BrandPromoBanners(props) {
  const {items} = props;

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const hasSeveralSlides = items.length > 1;

  return (
    <div className="brand-promo-banners relative flex h-[318px] w-full items-center phone:h-[190px] 500:!h-[160px]">
      {hasSeveralSlides && (
        <>
          <button
            type="button"
            ref={prevRef}
            aria-label="Previous slide"
            className="prev-btn-promo absolute left-[22px] top-1/2 z-[4] h-8 w-8 -translate-y-1/2 cursor-pointer rounded-full border border-solid border-[#D9D9D9] bg-white p-0 text-[0] leading-[0] outline-none"
          />
          <button
            type="button"
            ref={nextRef}
            aria-label="Next slide"
            className="next-btn-promo absolute right-[22px] top-1/2 z-[4] h-8 w-8 -translate-y-1/2 cursor-pointer rounded-full border border-solid border-[#D9D9D9] bg-white p-0 text-[0] leading-[0] outline-none"
          />
        </>
      )}

      <Swiper
        modules={[Autoplay, Keyboard, Navigation, Pagination]}
        slidesPerView={1}
        spaceBetween={0}
        loop={hasSeveralSlides}
        allowTouchMove={hasSeveralSlides}
        keyboard={{enabled: hasSeveralSlides}}
        autoplay={hasSeveralSlides ? {
          delay: 3000,
          disableOnInteraction: false,
        } : false}
        navigation={hasSeveralSlides ? {
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        } : false}
        pagination={hasSeveralSlides ? {
          type: 'progressbar',
          el: '#brand-promo-banners-pagination',
          progressbarFillClass: 'absolute left-0 top-0 h-full w-full origin-top-left bg-blue-primary',
        } : false}
        onBeforeInit={swiper => {
          if (!hasSeveralSlides) return;

          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        className="h-full w-full rounded-[14px]"
      >
        {items.map((banner, index) => (
          <SwiperSlide key={`brand-promo-banner-${banner.id || index}`}>
            <a
              href={banner.link || '#'}
              {...(banner.attribute_rel && {rel: banner.attribute_rel})}
              className="block h-full w-full overflow-hidden rounded-[14px]"
              onClick={() => eventEmitter.emit('showLoader')}
            >
              <picture className="block h-full w-full">
                {banner.mobilePicture?.avif && (
                  <source media="(max-width: 767px)" srcSet={banner.mobilePicture.avif} type="image/avif"/>
                )}
                {banner.mobilePicture?.webp && (
                  <source media="(max-width: 767px)" srcSet={banner.mobilePicture.webp} type="image/webp"/>
                )}
                {banner.mobilePicture?.orig && (
                  <source media="(max-width: 767px)" srcSet={banner.mobilePicture.orig}/>
                )}
                {banner.picture?.avif && <source srcSet={banner.picture.avif} type="image/avif"/>}
                {banner.picture?.webp && <source srcSet={banner.picture.webp} type="image/webp"/>}
                <img
                  src={banner.picture?.orig}
                  alt={banner.title || ''}
                  loading={index === 0 ? 'eager' : 'lazy'}
                  decoding="async"
                  fetchPriority={index === 0 ? 'high' : 'low'}
                  width={banner.picture?.width}
                  height={banner.picture?.height}
                  className="h-full w-full object-cover"
                />
              </picture>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {hasSeveralSlides && (
        <div
          id="brand-promo-banners-pagination"
          className="absolute bottom-[-11px] left-0 top-auto z-10 h-1 w-full bg-grey-10"
          style={{top: 'auto', bottom: '-20px'}}
        />
      )}
    </div>
  );
}

export default BrandPromoBanners;